const config = {
    build_number: '615160',
    build_timestamp: '2026-08-05T16:28:38.988Z',
    build_commit: 'aa14fde4fd6ed7b9cacbdc7071a5e60c5917f082',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
